import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	depTableNames: [],
	depTableSettings: {},
	dropdownList: {
		SkladOzn: [],
		VyrobekndOzn: [],
		MernaJdnId: [],
	},
	edit: {
		SkladOzn: null as number | null,
		VyrobekndOzn: null as string | null,
		NdNr: null as string | null,
		Text: null as string | null,
		Mnozstvi: null as number | null,
		MernaJdnId: null as number | null,
		ZakazkaId: null as number | null,
	},
	localState: {
		NdNrText: null as string | null,
		focusedElement: null as HTMLFormElement & any | null,
		ndNrId: null as number | null,
	},
	extraActions: {},
	extraMutations: {
		[editMutations.ND_NR_MAPPER](state, { data }) {
			state.localState.ndNrId = data.value;
			state.edit.NdNr = data.ndnr;
			state.edit.Text = data.text;
			state.edit.MernaJdnId = data.vydejmjid;
			state.edit.VyrobekndOzn = data.vyrobekndozn;
		},
	},
	extraGetters: {},
	props: {
		mode: null,
		filter: { ZakazkaId: null as number | null },
	},
});
